export default __webpack_public_path__ + "static/media/logo.e79db49eb37da928755277e869626df7.svg";